exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-message .top-message p{color:#fff;background-color:#073c4c;padding:15px 75px}@media (max-width:768px){.info-message .top-message p{padding:15px 35px}}.info-message .top-message p a{font-weight:800;color:#fff}.info-message .middle-message p{color:#073c4c;text-align:center;margin-top:1rem;font-size:18px}.info-message img{max-width:100%;transition:opacity .25s}.info-message img:hover{opacity:.7}", ""]);

// exports
